'use client'

import { useEffect, useState } from 'react'

import { Button } from '@ui/web/components'

import type { FaqItem } from '~/lib/landing'
import { Faq } from '~/lib/landing'

const OPEN_FAQ_EVENT = 'orang-tua:open-faq'
const CONNECT_FAQ_ID = 'hubungkan'
/** Leaves room for the sticky nav when scrolling to a question. */
const NAV_OFFSET = 88

const FAQ_ITEMS: FaqItem[] = [
  {
    id: 'usia',
    question: 'PiBo cocok untuk anak usia berapa?',
    answer:
      'PiBo dirancang untuk anak TK hingga SD, sekitar usia 4–12 tahun. Buku berjenjang tersedia dari tingkat paling awal hingga anak yang sudah lancar membaca, sehingga setiap anak bisa mulai dari kemampuannya sendiri. Semua konten dikurasi sesuai usia anak, dan PiBo bebas iklan.',
  },
  {
    id: 'durasi',
    question: 'Berapa lama sebaiknya anak memakai PiBo setiap hari?',
    answer:
      'Waktu belajar yang singkat tetapi rutin lebih bermanfaat daripada sesi panjang yang jarang. Untuk anak usia dini, 10–20 menit sehari sudah cukup untuk membangun kebiasaan membaca. Banyak aktivitas belajar juga mengajak anak mengamati, menggambar, atau mencoba sesuatu di luar layar. Orang tua bisa melihat berapa lama anak membaca dari akun keluarga.',
  },
  {
    id: CONNECT_FAQ_ID,
    question: 'Bagaimana menghubungkan akun keluarga dengan sekolah anak?',
    answer:
      'Jika sekolah anak sudah memakai PiBo, minta tautan undangan dari guru kelas. Buka tautannya, lalu masuk atau daftar akun keluarga, dan akun anak akan langsung terhubung dengan kelasnya. Jika sekolah sudah mengaktifkan Premium, akses itu juga bisa dipakai di rumah tanpa biaya tambahan.',
  },
  {
    id: 'beberapa-anak',
    question: 'Apakah satu akun bisa untuk beberapa anak?',
    answer:
      'Bisa. Orang tua dapat menambahkan beberapa anak dalam satu akun keluarga. Setiap anak punya profil sendiri, sehingga bacaan, rekomendasi, dan perkembangan belajarnya tercatat terpisah. Premium dihitung per anak, jadi orang tua bisa memilih anak mana yang ingin diaktifkan.',
  },
]

function scrollToFaq(id: string) {
  const target = document.getElementById(`faq-${id}`)
  if (!target) return
  window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - NAV_OFFSET, behavior: 'smooth' })
}

/** The FAQ list; opens a question when "Lihat caranya" asks for it, or when the URL hash names it. */
export function ParentFaq() {
  const [open, setOpen] = useState<string[]>([])

  useEffect(() => {
    const openItem = (id: string) => {
      setOpen((current) => (current.includes(id) ? current : [...current, id]))
      requestAnimationFrame(() => scrollToFaq(id))
    }
    const onOpen = (event: Event) => openItem((event as CustomEvent<string>).detail)

    if (window.location.hash === `#faq-${CONNECT_FAQ_ID}`) openItem(CONNECT_FAQ_ID)

    window.addEventListener(OPEN_FAQ_EVENT, onOpen)
    return () => window.removeEventListener(OPEN_FAQ_EVENT, onOpen)
  }, [])

  return <Faq items={FAQ_ITEMS} value={open} onValueChange={setOpen} />
}

/** "Lihat caranya": scrolls to the connect-to-school question and opens it. */
export function OpenConnectFaqButton() {
  return (
    <Button
      variant='outline'
      size='lg'
      onClick={() => window.dispatchEvent(new CustomEvent(OPEN_FAQ_EVENT, { detail: CONNECT_FAQ_ID }))}
    >
      Lihat caranya
    </Button>
  )
}
